<template>
  <div v-if="open" class="support-overlay" @click.self="$emit('close')">
    <div class="support-drawer" role="dialog" aria-modal="true" :aria-label="t('support.title')">
      <header class="support-drawer__head">
        <!-- No unread badge here: the open chat has just been read (the server marks what it serves). -->
        <h2 class="support-drawer__title">
          <SupportManagerHeader :manager="manager" />
        </h2>
        <button class="support-drawer__close" :aria-label="t('common.back')" @click="$emit('close')">&times;</button>
      </header>

      <SupportChat :active="open" :ticket-id="supportTicketId" @update:manager="manager = $event" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SupportChat from './SupportChat.vue';
import SupportManagerHeader from './SupportManagerHeader.vue';
import { useSupport } from '@/composables/useSupport';
import { DEFAULT_MANAGER, type ManagerView } from '@/api/support';

defineProps<{ open: boolean }>();
defineEmits<{ close: [] }>();
const { t } = useI18n();
const { supportTicketId } = useSupport();
const manager = ref<ManagerView>(DEFAULT_MANAGER);
</script>

<style scoped lang="scss">
.support-overlay {
  position: fixed; inset: 0; z-index: 1000;
  background: rgba(10, 8, 5, 0.55);
  display: flex; justify-content: flex-end;
}
.support-drawer {
  width: min(92vw, 420px);
  background: var(--bg-base);
  display: flex; flex-direction: column;
  box-shadow: -16px 0 40px rgba(0, 0, 0, 0.5);
}
.support-drawer__head {
  padding: 16px;
  display: flex; align-items: center; justify-content: space-between;
  border-bottom: 1px solid var(--hairline);
}
.support-drawer__title { margin: 0; min-width: 0; font-weight: inherit; }
.support-drawer__close {
  background: none; border: none; color: var(--text-2);
  font-size: 24px; line-height: 1; cursor: pointer;
}
</style>
